import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableMcControl } from "./autogen/AutogenLayoutUserTableMcControl";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableMcControl extends AutogenLayoutUserTableMcControl implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.MC_CONTROL;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
